// components/steps/StepMood.jsx
import React, { useState, useEffect } from 'react';

const moods = [
  'Relaxing',
  'Adventurous',
  'Cultural',
  'Romantic',
  'Party',
  'Business'
];

const StepMood = ({ data, updateData, skip, goBack }) => {
  // allow multiple selections
  const [selected, setSelected] = useState(data.mood || []);

  // sync when navigating back
  useEffect(() => {
    setSelected(Array.isArray(data.mood) ? data.mood : data.mood ? [data.mood] : []);
  }, [data.mood]);

  const toggle = (m) => {
    setSelected(prev =>
      prev.includes(m) ? prev.filter(x => x !== m) : [...prev, m]
    );
  };

  const isNextDisabled = selected.length === 0;

  const handleNext = () => {
    if (!isNextDisabled) {
      updateData('mood', selected);
    }
  };

  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-center">
        What’s the mood of your trip?
      </h2>

      {/* Mood options */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
        {moods.map(m => (
          <button
            key={m}
            onClick={() => toggle(m)}
            className={`px-4 py-2 rounded-lg border text-sm transition-colors whitespace-nowrap
              ${selected.includes(m)
                ? 'bg-blue-500 text-white border-transparent'
                : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'}`}
          >
            {m}
          </button>
        ))}
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        {goBack ? (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        ) : <div />}

        <div className="flex items-center gap-2">
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`px-6 py-2 rounded-lg transition 
              ${isNextDisabled
                ? 'bg-blue-300 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          >
            Next
          </button>
          <button
            onClick={skip}
            className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepMood;
